// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".empty-result[data-v-7232feb1]{text-align:center;font-size:larger;font-weight:bolder;padding:30px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
